import { render, staticRenderFns } from "./CareerDetailsPsy.vue?vue&type=template&id=0545e18e&scoped=true"
import script from "./CareerDetailsPsy.vue?vue&type=script&lang=js"
export * from "./CareerDetailsPsy.vue?vue&type=script&lang=js"
import style0 from "./CareerDetailsPsy.vue?vue&type=style&index=0&id=0545e18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545e18e",
  null
  
)

export default component.exports